/*=========================================================================================
  File Name: moduleMap.js
  Description: Todo Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import state from "./moduleSettingState.js";
import mutations from "./moduleSettingMutations.js";
import actions from "./moduleSettingActions.js";
import getters from "./moduleSettingGetters.js";

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
};
